import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
const checks = ['Acceso inmediato', 'PDF descargable', 'Funciona en celular', 'Garantía 7 días', 'Pago 100% seguro', 'Sin suscripciones'];
export function FinalCTA() {
  const scrollToCTA = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: 'smooth'
    });
  };
  return <section className="py-24 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center" data-id="element-47">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} data-id="element-48">
        <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-dark mb-8 leading-tight" data-id="element-49">
          ¿Vas a seguir buscando en Google a las 2am con el corazón acelerado...
          <br data-id="element-50" />
          <span className="text-brand-primary" data-id="element-51">
            ...o vas a tener la respuesta correcta en tus manos en los próximos
            2 minutos?
          </span>
        </h2>

        <div className="flex items-center justify-center gap-4 text-2xl sm:text-3xl font-bold mb-8" data-id="element-52">
          <span className="text-gray-400 line-through text-xl sm:text-2xl" data-id="element-53">
            $19.99
          </span>
          <span className="text-brand-accent text-4xl sm:text-5xl" data-id="element-54">
            🔥 HOY SOLO $11.99
          </span>
        </div>

        <CTAButton className="w-full sm:w-auto mb-10 text-xl md:text-2xl py-6 px-12" data-id="element-55">
          💊 SÍ, QUIERO MI GUÍA AHORA — $11.99
        </CTAButton>

        <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 mb-12 max-w-3xl mx-auto" data-id="element-56">
          {checks.map((check, index) => <div key={index} className="flex items-center gap-2 text-brand-secondary font-medium" data-id="element-57">
              <Check className="w-5 h-5 text-brand-success" data-id="element-58" />
              <span data-id="element-59">{check}</span>
            </div>)}
        </div>

        <div className="flex flex-wrap justify-center gap-4 opacity-70" data-id="element-60">
          {['VISA', 'Mastercard', 'PayPal', 'AMEX'].map(logo => <div key={logo} className="bg-white px-4 py-2 rounded-md shadow-sm border border-gray-200 font-bold text-gray-500 text-sm tracking-wider" data-id="element-61">
              {logo}
            </div>)}
        </div>
      </motion.div>
    </section>;
}